import { Components, Theme } from '@mui/joy';

export const JoyCheckboxConfig: Partial<Components<Theme>> = {
  JoyCheckbox: {
    styleOverrides: {
      root: ({ theme }) => {
        return {
          '&.invalid .MuiCheckbox-checkbox': {
            borderColor: theme.palette.danger['500'],
          },
        };
      },
      checkbox: ({ theme, ownerState }) => {
        return {
          borderRadius: '0',
          borderWidth: '2px',
          borderColor: theme.palette.neutral[600],
          backgroundColor: theme.palette.common.white,
          ...(ownerState.checked && {
            backgroundColor: theme.palette.primary['500'],
            '&:hover': {
              backgroundColor: theme.palette.neutral['800'],
            },
          }),
        };
      },
    },
  },
};
